import { fixedBody } from '../lib/fixedBody'

const getCsrfToken = () => {
	const metas = document.getElementsByTagName('meta')
	for (let meta of metas) {
		if (meta.getAttribute('name') === 'csrf-token') {
			return meta.getAttribute('content')
		}
	}
	return ''
}

const fetchReview = (url, method) =>
	fetch(url, {
		method: method,
		credentials: 'same-origin',
		headers: {
			'Content-Type': 'application/json',
			'X-CSRF-Token': getCsrfToken(),
		},
		body: JSON.stringify({}),
	})
		.then((response) => {
			if (300 <= response.status && response.status <= 399) {
				location.href = response.location
			} else if (response.status === 401) {
				response.json().then((json) => {
					location.href = json.location
				})
			} else if (response.status === 204) {
				return ''
			} else {
				return response.json()
			}
		})
		.catch((error) => {
			return undefined
		})

const toBoolean = (booleanStr) => {
	return booleanStr && booleanStr.toLowerCase() === 'true'
}

export default {
	data: () => ({
		isFavorited: true,
		errorMessage: '',
	}),
	beforeDestroy() {
		console.log('Component destroying...')
	},
	mounted() {
		this.isFavorited = toBoolean(this.$el.dataset.favorited)
		console.log('Component mounted, favorited status:', this.isFavorited)

		this.$nextTick(() => {
			const detailButton = this.$el.querySelector('[data-key]')
			if (detailButton) {
				console.log('Detail button found:', detailButton.dataset.key)
			}
		})
	},
	methods: {
		fetch: function(event) {
			const url = `${event.target.dataset.href}.json`
			const method = event.target.dataset.method
			fetchReview(url, method)
				.then((json) => {
					console.log('Fetch response:', json)
					if (json['status'] === 'bad_request') {
						this.errorMessage = json.message
						return
					}

					if (json['status'] === 'ok') {
						this.isFavorited = true
					} else {
						this.isFavorited = false
					}
				})
				.catch(function(json) {
					console.error('Fetch error:', json)
				})
		},
		onClickDetail: function(event) {
			event.preventDefault() // イベントのデフォルト動作を防止

			if (!event.target.dataset) {
				console.error('No dataset found on target element')
				return
			}

			const key = event.target.dataset.key
			const id = event.target.dataset.id
			console.log('Detail clicked:', { key, id })

			// イベントの直接実行に変更
			const $content = $(`.js-postdetail--content[data-key="${key}"]`)
			if ($content.length) {
				$content.addClass('active')
				setTimeout(() => {
					try {
						fixedBody()
						history.pushState(null, null, `/posts/${id}`)
						console.log('Detail view opened successfully')
					} catch (error) {
						console.error('Error opening detail view:', error)
					}
				}, 10)
			} else {
				console.error('Content element not found for key:', key)
			}
		},
	},
}
